import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.includes.js";
import { getRetailer, getRetailerActiveMemberships, getRetailerTaxableCountry } from "@faire/help-center-utils/serialized-data/getRetailer";
import { IRetailer } from "@faire/web-api/indigofair/data/IRetailer";
import { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";
import { THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES } from "@faire/web/common/consts/THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES";
export var isAusRetailer = function isAusRetailer() {
  return getRetailerTaxableCountry() === ISO3166Alpha3.AUS;
};
export var isCanRetailer = function isCanRetailer() {
  return getRetailerTaxableCountry() === ISO3166Alpha3.CAN;
};
export var isEurRetailer = function isEurRetailer() {
  var retailerCountry = getRetailerTaxableCountry();
  return THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES.map(String).includes(retailerCountry !== null && retailerCountry !== void 0 ? retailerCountry : "");
};
export var isActiveInsider = function isActiveInsider() {
  var retailer = getRetailer();
  var retailerActiveMemberships = getRetailerActiveMemberships();
  return (retailer === null || retailer === void 0 ? void 0 : retailer.insider_membership_state) === IRetailer.InsiderMembershipState.ACTIVE || !!retailerActiveMemberships;
};